module.exports = __webpack_public_path__ + "static/media/neutral.9657b64d.png";